// extracted by mini-css-extract-plugin
export var container = "_cg-0";
export var containerTopRight = "_cg-1";